import React, { ReactNode } from "react"
import { MasterLayout } from "components/views/atoms/layouts/MasterLayout"
import { PageHeader } from "components/views/molecules/Molecules"
import { Container } from "@carrotfertility/carotene"

type InboundMemberPaymentProps = {
  children: ReactNode
}

export function InboundMemberPaymentsLayout({ children }: InboundMemberPaymentProps): JSX.Element {
  const InboundMemberPaymentsHeader = (): JSX.Element => {
    return <PageHeader icon="icn-carrot-cards" title={`Make a payment`} />
  }
  return (
    <Container sx={{ position: "relative" }}>
      <MasterLayout header={<InboundMemberPaymentsHeader />}>{children}</MasterLayout>
    </Container>
  )
}
